<template>
    <div>
        <nav class="navbar navbar-expand-lg navbar-light">
            <div class="ml-auto">
                <br/>
                <form v-on:keypress.enter.prevent="searchEditShipping" class="form-inline my-2 my-lg-0">
                    <date-picker
                        v-model="search.date"
                        type="date"
                        :format="changeFormat"
                        :lang="lang"
                        placeholder="วันที่อัพเดต">
                    </date-picker>
                    &nbsp
                    <button @click="searchEditShipping"
                            class="btn btn-success my-2 my-sm-0"
                            type="button">
                        <icon name="search"></icon>
                        ค้นหา
                    </button>
                    &nbsp
                </form>
            </div>
        </nav>
        <div class="col-sm-12 table-responsive">
            <table class="table table-bordered text-center">
                <thead>
                <tr>
                    <th scope="col">วันที่แก้ไข</th>
                    <th scope="col">ชื่อร้าน</th>
                    <th scope="col">อำเภอ</th>
                    <th scope="col">จังหวัด</th>
                    <th scope="col">ภาค</th>
                    <th scope="col">รายการที่ปรับแก้</th>
                    <th scope="col">Action</th>
                    <th scope="col">จำนวน (บาท)</th>
                    <th scope="col">ผู้แก้ไข</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="data in shipping_fee">
                    <td>{{ data.date | moment("DD/MM/YYYY") }}</td>
                    <td>
                        <template v-if="data.customer_name == all">
                            ทั้งหมด
                        </template>
                        <template
                            v-else-if="data.customer_name && (data.district == 'all sale' || data.province == 'all sale' || data.area_id == 'all sale')">
                            {{ data.sale.sale_id + ' ' + data.sale.name }}
                        </template>
                        <template v-else-if="!data.customer_id && data.customer_name && data.customer_name != '-'">ต.{{ data.customer_name }}</template>
                        <template v-else>{{ data.customer_name }}</template>
                    </td>
                    <td>
                        <template v-if="data.district == all">
                            ทั้งหมด
                        </template>
                        <template v-else-if="data.district == 'all sale'">
                            เซล
                        </template>
                        <template v-else>{{ data.district }}</template>

                    </td>
                    <td>
                        <template v-if="data.province == all">
                            ทั้งหมด
                        </template>
                        <template v-else-if="data.province == 'all sale'">
                            เซล
                        </template>
                        <template v-else>{{ data.province }}</template>
                    </td>
                    <td>
                        <template v-if="data.area_id == all">
                            ทั้งหมด
                        </template>
                        <template v-else-if="data.area_id == 'all sale'">
                            เซล
                        </template>
                        <template v-else-if="data.area_id">
                            {{ data.area_id }}
                        </template>
                        <template v-else>-</template>
                    </td>
                    <td>
                        {{ data.list_name }}
                    </td>
                    <td>
                        <template v-if="data.action == 1">
                            เพิ่ม
                        </template>
                        <template v-else>
                            ลด
                        </template>
                    </td>
                    <td>
                        {{ data.amount | currency }}
                    </td>
                    <td v-if="data.user">
                        <template v-if="data.user">
                            {{ data.user.name }}
                        </template>
                        <template v-else>
                            -
                        </template>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <!--paginate-->
        <div v-if="shipping_fee.length > 0">
            <vue-pagination :pagination="dataPaginate"
                            @paginate="getEditShippingTable">
            </vue-pagination>
        </div>
        <br/>
        <!--<pre class="alert alert-primary">{{ shipping_fee }}</pre>-->
    </div>
</template>

<script>
import {mapState} from "vuex";
import VuePagination from "../../Pagination";
import DatePicker from 'vue2-datepicker'
import moment from "moment";

export default {
    components: {
        VuePagination,
        DatePicker
    },
    name: "edit-shipping-table",
    data() {
        return {
            all: "all",
            dateFormat: 'D MMM YYYY',
            search: {
                date: ""
            },
            changeFormat: {
                stringify: (date) => {
                    let date_moment = moment(date).format('YYYY');
                    const year = parseInt(date_moment) + 543;
                    //console.log(moment(date).format('DD/MM/'+year));
                    return date ? moment(date).format('DD/MM/' + year) : null
                },
                parse: (value) => {
                    return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                }
            },
            lang: {
                days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                placeholder: {
                    date: 'วว/ดด/ปปปป',
                }
            },
        }
    },
    created() {
        this.$store.dispatch('Shipping/setShipping');
    },
    computed: {
        ...mapState({
            shipping_fee: state => {
                return state.Shipping.shipping_fee;
            },
            dataPaginate: state => {
                return state.Shipping.dataPaginate;
            }
        })
    },
    methods: {
        getEditShippingTable() {
            const page = this.dataPaginate.current_page;
            this.$store.dispatch('Shipping/setShipping', page);
        },
        formatDates(dateOne) {
            let formattedDates = ''
            if (dateOne) {
                formattedDates = format(dateOne, this.dateFormat)
            }
            return formattedDates
        },
        searchEditShipping() {
            this.search.date = moment(this.search.date).format("YYYY-MM-DD");

            this.$store.dispatch('Shipping/search', this.search).then(() => {
                this.search.date = "";
            });
        }
    }
}
</script>

<style scoped>

</style>
